import axios from '../../api/instance';

const namespace = 'available_contact_moments/';

const SET_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_AVAILABLE_CONTACT_MOMENTS';
const SET_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_FETCHING_AVAILABLE_CONTACT_MOMENTS';

export const SET_SELECTED_OPTION = namespace + 'SET_SELECTED_OPTION';
export const SET_COMMENT = namespace + 'SET_COMMENT';
export const SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS';

export const FETCH_AVAILABLE_CONTACT_MOMENTS = namespace + 'FETCH_AVAILABLE_CONTACT_MOMENTS';
export const GET_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_AVAILABLE_CONTACT_MOMENTS';
export const GET_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_FETCHING_AVAILABLE_CONTACT_MOMENTS';
export const GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS';
export const GET_SELECTED_OPTION = namespace + 'GET_SELECTED_OPTION';
export const GET_COMMENT = namespace + 'GET_COMMENT';



export default {
    state: {
        availableContactMoments: [],
        fetchingAvailableContactMoments: false,
        errorFetchingAvailableContactMoments: false,
        selectedOption: null,
        comment: '',
    },
    mutations: {
        [SET_AVAILABLE_CONTACT_MOMENTS]: (state, availableContactMoments) => state.availableContactMoments = availableContactMoments,
        [SET_FETCHING_AVAILABLE_CONTACT_MOMENTS]: (state, fetching) => state.fetchingAvailableContactMoments = fetching,
        [SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS]: (state, error) => state.errorFetchingAvailableContactMoments = error,
        [SET_SELECTED_OPTION]: (state, option) => state.selectedOption = option,
        [SET_COMMENT]: (state, comment) => state.comment = comment,
    },
    actions: {
        async [FETCH_AVAILABLE_CONTACT_MOMENTS] ({commit}, { type = 'salt'} = {})  {
            try {
                commit(SET_FETCHING_AVAILABLE_CONTACT_MOMENTS, true);
                let experiences = await axios.get('/planners/api/planners/available_x_contact_moments', { params: { type } });
                commit(SET_AVAILABLE_CONTACT_MOMENTS, experiences);
            } finally {
                commit(SET_FETCHING_AVAILABLE_CONTACT_MOMENTS, false);
            }
        },
    },
    getters: {
        [GET_AVAILABLE_CONTACT_MOMENTS]: (state) => state.availableContactMoments,
        [GET_FETCHING_AVAILABLE_CONTACT_MOMENTS]: (state) => state.fetchingAvailableContactMoments,
        [GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS]: (state) => state.errorFetchingAvailableContactMoments,
        [GET_SELECTED_OPTION]: (state) => state.selectedOption,
        [GET_COMMENT]: (state) => state.comment,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/available_contact_moments.js